export default "__VITE_ASSET__Bhq_QWSe__"